import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Modal,
  Typography,
  TextField,
  Paper,
  Container,
  Autocomplete,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  ObtenerDatosConductores,
  EditarSolicitudProveedor,
} from "../../../APIS/apiProveedor";

const ModificarConductor = ({ open, setOpen, folio, Idd }) => {
  const [ConductorProvee, setConductorProvee] = useState("");
  const [UltimaActualizacionConductor, setUltimaActualizacionConductor] = useState("");
  const [conductoresDisponibles, setConductoresDisponibles] = useState([]);
  const [telefonoCounter, setTelefonoCounter] = useState("");
  const [modeloConductor, setModeloConductor] = useState("");
  const [marcaConductor, setMarcaConductor] = useState("");
  const [patenteConductor, setPatenteConductor] = useState("");
  const [colorConductor, setColorConductor] = useState("");
  const [year, setYear] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mostrarAlertaExito, setMostrarAlertaExito] = useState(false);

  const [nrt, setNRT] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (open && folio?.Datos?.counter) {
        const lista = await ObtenerDatosConductores(folio.Datos.counter);
        setConductoresDisponibles(lista || []);
  
        const storedFirstname = localStorage.getItem("firstname");
        if (storedFirstname) {
          const currentTime = new Date().toLocaleTimeString();
          const message = `Última actualización realizada por ${storedFirstname} a las ${currentTime}`;
          setUltimaActualizacionConductor(message);
        }
  
        setSelectedOption(folio?.Datos?.selectedOption || "");
        setNRT(folio?.Datos?.nrt || "");
  
        // Buscar el viaje correspondiente
        const viajeEncontrado = folio.Viaje?.find((viaje) => viaje.idd === Idd);
        if (viajeEncontrado?.DatosProveedor?.ConductorProvee) {
          const nombre = viajeEncontrado.DatosProveedor.ConductorProvee;
          setConductorProvee(nombre);
  
          // Esperar que la lista se cargue y luego buscar los detalles del conductor
          const conductor = lista.find(
            (item) => item?.Datos?.nombre === nombre
          );
          if (conductor) {
            setTelefonoCounter(conductor.Datos.telefono || "");
            setModeloConductor(conductor.Datos.modelo || "");
            setMarcaConductor(conductor.Datos.marca || "");
            setPatenteConductor(conductor.Datos.patente || "");
            setColorConductor(conductor.Datos.color || "");
            setYear(conductor.Datos.year || "");
          }
        }
      }
    };
  
    fetchData();
  }, [open, folio, Idd]);
  

  const handleGuardar = async () => {
    if (!ConductorProvee) {
      setMostrarAlerta(true);
      return;
    }

    const proveedorData = {
      ConductorProvee,
      StatusConductor: "En espera",
      UltimaActualizacionConductor,
    };

    try {
      await EditarSolicitudProveedor(selectedOption, nrt, Idd, proveedorData);
      setMostrarAlertaExito(true);
      setIsEditing(false);
      setOpen(false);
    } catch (error) {
      console.error("Error al guardar:", error);
      setMostrarAlerta(true);
    }
  };

  const handleClose = () => {
    if (isEditing) {
      if (window.confirm("Tienes cambios sin guardar. ¿Quieres salir sin guardar?")) {
        setIsEditing(false);
        setOpen(false);
      }
    } else {
      setOpen(false);
    }
  };

  const showModal = !!folio && folio.id.match(/CHILP|DPSCL|PISCL|SPA|ATLAS|KPS|SE|Aero/);

  return (
    <>
      {showModal && (
        <Modal open={open} onClose={handleClose}>
          <Paper
            sx={{
              p: 3,
              flexGrow: 1,
              width: "70%",
              maxWidth: "500px",
              maxHeight: "80vh",
              overflowY: "auto",
              backgroundColor: "#fff",
              borderRadius: "30px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Container maxWidth="xxl">
              <Box component="form" noValidate autoComplete="off">
                <Typography
                  style={{
                    width: "100%",
                    textAlign: "center",
                    backgroundColor: "rgb(17, 25, 42)",
                    color: "white",
                    borderRadius: "30px",
                  }}
                  variant="h6"
                  fontWeight="bold"
                >
                  CONDUCTOR
                </Typography>
                <br />

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-conductores"
                      options={conductoresDisponibles}
                      getOptionLabel={(option) => option?.Datos?.nombre || ""}
                      value={conductoresDisponibles.find(
                        (item) => item?.Datos?.nombre === ConductorProvee
                      ) || null}
                      onChange={(event, newValue) => {
                        setConductorProvee(newValue?.Datos?.nombre || "");
                        setTelefonoCounter(newValue?.Datos?.telefono || "");
                        setModeloConductor(newValue?.Datos?.modelo || "");
                        setMarcaConductor(newValue?.Datos?.marca || "");
                        setPatenteConductor(newValue?.Datos?.patente || "");
                        setColorConductor(newValue?.Datos?.color || "");
                        setYear(newValue?.Datos?.year || "");
                        setIsEditing(true);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Asignar Conductor" fullWidth />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Teléfono Conductor"
                      InputLabelProps={{ shrink: true }}
                      value={telefonoCounter}
                      disabled
                    />
                  </Grid>

                  <Typography
                    sx={{ mt: 2, ml: 2 }}
                    style={{
                      width: "100%",
                      textAlign: "center",
                      backgroundColor: "rgb(17, 25, 42)",
                      color: "white",
                      borderRadius: "30px",
                    }}
                    variant="h6"
                    fontWeight="bold"
                  >
                    DATOS DEL VEHÍCULO
                  </Typography>

                  <Grid item xs={12}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Modelo"
                      InputLabelProps={{ shrink: true }}
                      value={modeloConductor}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Marca"
                      InputLabelProps={{ shrink: true }}
                      value={marcaConductor}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Patente"
                      InputLabelProps={{ shrink: true }}
                      value={patenteConductor}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Color"
                      InputLabelProps={{ shrink: true }}
                      value={colorConductor}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ backgroundColor: grey[100], width: "100%" }}
                      label="Año"
                      InputLabelProps={{ shrink: true }}
                      value={year}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="success"
                      sx={{
                        bgcolor: "#a5d6a7",
                        fontWeight: "bold",
                        color: "green",
                        width: "100%",
                      }}
                      onClick={handleGuardar}
                    >
                      Guardar
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="error"
                      sx={{
                        bgcolor: "#f8bbd0",
                        fontWeight: "bold",
                        color: "red",
                        width: "100%",
                      }}
                      onClick={handleClose}
                    >
                      Cerrar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Paper>
        </Modal>
      )}

      <Snackbar
        open={mostrarAlerta}
        autoHideDuration={3000}
        onClose={() => setMostrarAlerta(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert severity="error" style={{ fontWeight: "bold" }}>
          Por favor, seleccione un conductor válido.
        </Alert>
      </Snackbar>

      <Snackbar
        open={mostrarAlertaExito}
        autoHideDuration={3000}
        onClose={() => setMostrarAlertaExito(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert severity="success" style={{ fontWeight: "bold" }}>
          ¡Conductor asignado con éxito! Orden {nrt}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ModificarConductor;
